<template>
  <div id="footer-div">
    <footer
      class="footer text-center fixed-bottom"
      style="background-color: #2e88c5"
    >
      <div class="container d-flex justify-content-center py-3">
        <p style="color: white">© 2025 Copyright &nbsp;</p>
        <br />
        <a href="https://www.ptspace.pt" target="_blank"
          ><img src="../assets/PT_Space.png" alt="" width="150;" height="auto"
        /></a>
      </div>
    </footer>
  </div>
  <!-- End of .container -->
</template>
<script>
  import { useRoute } from "vue-router";
  export default {
    setup() {
      const route = useRoute();
      const routeName = route.path.slice(1);
      return {
        routeName,
      };
    },
    data() {
      return {};
    },
    mounted() {
      window.scrollTo(0, 0);
    },
    methods: {},
  };
</script>
